module.exports = __webpack_public_path__ + "img/step2.be544e99.svg";